export function escapeRegExp(str) {
  return str && str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') || '';
}
